import HierarchyCreateContainer from './hierarchy_create_container';

const HierarchyCreate = HierarchyCreateContainer;

export default HierarchyCreate;
